
import { useRoute, useRouter } from 'vue-router'
import { reactive, getCurrentInstance, watch, onMounted,defineComponent,toRefs, ref,computed,nextTick } from 'vue'
import { useStore } from '@/store/index'
import { VueDraggableNext } from 'vue-draggable-next'
import { Plus, Delete } from '@element-plus/icons-vue'
import * as Enum from './enum';
import Lunar from 'lunar-javascript';
import { isWithinRange, isNationalDayRange } from '@/utils/index'
import { isSensitive } from '@/utils/validator'
import { AppActionTypes } from '@/store/modules/app/action-types'

interface ListM {
    id:     number,     // ID
    name:   string,     // 名称
}
export default defineComponent({
name: 'ProductEdit',
components: {
    Plus,
    Delete,
    draggable: VueDraggableNext,
},
setup () {
    const { proxy } = getCurrentInstance() as any
    const router = useRouter()
    const route = useRoute()
    const store = useStore()
    const { t } = route.query
    const userType = store.state.user.userInfo.user_type
    const userId = store.state.user.userInfo.id
    const userName = store.state.user.userInfo.username
    // const enumTypes = Types;
    // const enumWayTypes = WayTypes;
    // const enumInvoiceType = InvoiceELectron;
    const state = reactive ({
        t:                      route.query.t,   //1编辑 2 查看
        brandType:              '',
        brandList:              [],     // 品牌列表
        formData: {
            rule_start_date:    '',     //配规开始时间
            rule_end_date:      '',     //配规结束时间
            brand_id:           '',     //品牌id
            ship_type:          '',     //配送类型
            distribution_range: '',     //配规描述
            ship_amount:        '',     //运费
            white_reson:        '',     //白名单原因
            city_id:            '',     //城市id
            yingye_status:      '',     //营业状态
            stop_start_date:    '',     //闭店开始日期
            stop_end_date:      '',     //闭店结束日期
            can_ship:           '',     //是否支持上门
            ship_start_date:    '',     //上门配送开始日期
            ship_end_date:      '',     //上门配送结束日期
            ship_times:         '',   //上门配送时间段 
            can_take:           '',     //是否支持自提
            take_start_date:     0,     //自提开始日期
            take_end_date:      '',    //自提结束日期
            take_times:         '',    //自提时间段
            brand_cat_id:       '',     //品牌分类id
        },
        newYearEnd:             '',     //春节后10天
        NextYearEnd:            '',     //下一年春节后10天
        nationalDayEnd:         '',     //国庆节后7天

        shipType:               '',     //根据登录用户判断所属配送类型

        cityList:               [],     // 城市列表
        cityIds:                [],     // 全部城市ID集合
        cityListLen:            0,      // 全部城市列表长度
        isSelectedAll:          false,  // 城市全选状态
        isIndeterminate:        false,  // 城市全选中间状态
        trimField: (value) => {
            let regex = /^\s+|\s+$/g; // 匹配开头和结尾的空白字符
            return value.replace(regex, ''); // 去除开头和结尾的空白字符
        },
        // 滑动到表单错误项
        moveToErr: () => {
            nextTick(() => {
                let isErr = document.getElementsByClassName('is-error')
                if (isErr.length) {
                    isErr[0].scrollIntoView({
                        block: 'center',
                        behavior: 'smooth'
                    })
                }
            })
        },
        onInput: (val) => {
             // 定义正则表达式
            const regex = /^[0-9,:-]+$/;
            // 检查formData.ship_times是否符合正则表达式
            if (val && !regex.test(val)) {
                proxy.$message({ type: 'error', message: '输入格式错误，注意输入英文符号' })
            }
        },
        submitForm: async() => {
           const sensitiveResult = await isSensitive(state.formData.distribution_range)
           if (sensitiveResult !== true) return proxy.$message({ type: 'error', message: `配规描述中包含敏感词：${sensitiveResult}` })
           proxy.$refs['brandRule'].validate((valid:boolean) => {
               if(valid){
                    const regex = /^[0-9,:-]+$/;
                    // 检查formData.ship_times是否符合正则表达式
                    if (state.formData.ship_times && !regex.test(state.formData.ship_times)) {
                        return proxy.$message({ type: 'error', message: '配送时间段输入格式错误，注意输入英文符号' })
                    }
                    if (state.formData.take_times && !regex.test(state.formData.take_times)) {
                        return proxy.$message({ type: 'error', message: '自提时间段输入格式错误，注意输入英文符号' })
                    }
                //选择营业则自提和配送选择一个
                    if(state.formData.ship_type == 2 &&state.formData.yingye_status == 1 && state.formData.can_take == 2 && state.formData.can_ship == 2){
                        return proxy.$message({ type: 'error', message: '自提和配送至少选择一个' })
                    }
                    if(state.formData.yingye_status ==2 && !state.formData.stop_start_date || state.formData.yingye_status ==2 && !state.formData.stop_end_date){
                        return proxy.$message({ type: 'error', message: '若不营业请选择闭店时间' })
                    }
                   proxy.$http.post('/admin/brands/set_cj_distribution_rule', state.formData).then(res => {
                        const { code, msg } = res
                        if (code != 200) {return proxy.$message({ type: 'error', message: msg}) }
                        proxy.$message({ type: 'success', message: '保存成功' })
                        router.go(-1)
                   })
               }
           })
        },
        onCatChange: (val) => {
            state.formData.cat_id = val
        }, 
        
    })
    // 获取品牌关联城市
    const getCityList = () =>{
        proxy.$http.get('/cake_api/getCityListByBrandId', {brand_id: state.formData.brand_id}).then((res:any) => {
            const { code, data, msg } = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            state.cityList = data

            // 组合全部城市ID集合，计算城市个数，供全选功能使用
            let cityListLen = 0
            let cityIds = []
            data.map(item => {
                const { options } = item
                cityListLen += options.length
                options.map(subItem => {
                    // @ts-ignore
                    cityIds.push(subItem.id)
                })
            })
            state.cityListLen = cityListLen
            state.cityIds = cityIds
        })
    }
    //获取品牌列表
    const getBrandList = () => {
        proxy.$http.get('/cake_api/get_brand_list').then((res:any) => {
            const {code, data, msg} = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            state.brandList = res.data
        })
    }
    const onBrandChange = (val) => {
        state.formData.brand_cat_id = state.brandList.find(item => item.id === val).cat_id // 重新定义当前品牌品类
        state.formData.brand_id = val
    }
    /**
     * 白名单时间范围 须在 配规时间范围之内 即配规结束时间（可大2天）可大于白名单结束时间
    */
    //配规开始结束时间
    const disabledStartRuleDate = (date) => { // 返回开始不可用日期
        //所选时间小于等于当前日期
        return (date.getTime()) <= Date.now() - 1000*60*60*24 
    }
    const disabledEndRuleDate = (date) => { // 返回结束不可用日期
        const currentDate = new Date().getTime(); // 当前日期时间戳
        //判断当前时间是否在白名单时间内
        if(isFestival(currentDate)){
            //按照每年春节结束和国庆结束+2之后不可选不可选
             return !((date.getTime()) >= Date.now() - 1000*60*60*24*10 && (date.getTime()) <= state.newYearEnd) ||
                    !((date.getTime()) >= Date.now() - 1000*60*60*24*10 && (date.getTime()) <= state.NextYearEnd)
        }else if(isNationalDayRange(currentDate)) {
            return !((date.getTime()) >= Date.now() - 1000*60*60*24*10 && (date.getTime()) <= state.nationalDayEnd)
        }else {
            //所选时间小于等于当前日期
            return (date.getTime()) <= Date.now() - 1000*60*60*24
        }
       
    }
    //动态监听配规开始结束时间，来约束闭店时间
    const disabledStartStopDate = (date) => { // 返回开始不可用日期
        //将时间转换为时间戳
        const start = new Date(state.formData.rule_start_date).getTime()
        const end = new Date(state.formData.rule_end_date).getTime()
        //所选时间要大于配规开始时间且要小于配规结束时间
        return !((date.getTime()) >= start - 1000*60*60*24 && (date.getTime()) <= end);
    }
    const disabledEndStopDate = (date) => { // 返回结束不可用日期
        //将时间转换为时间戳
        const start = new Date(state.formData.rule_start_date).getTime()
        const end = new Date(state.formData.rule_end_date).getTime()
        //所选时间要小于配规结束时间
        return !((date.getTime()) >= start - 1000*60*60*24 && (date.getTime()) <= end);
    }
    //动态监听配规开始结束时间，来约束配送等时间
    const disabledStartDate = (date) => { // 返回开始不可用日期
        //将时间转换为时间戳
        const start = new Date(state.formData.rule_start_date).getTime()
        const end = new Date(state.formData.rule_end_date).getTime()
        //所选时间要大于配规开始时间且要小于配规结束时间
        return !((date.getTime()) >= start - 1000*60*60*24 && (date.getTime()) <= end);
    }
    const disabledEndDate = (date) => { // 返回结束不可用日期
        //将时间转换为时间戳
        const start = new Date(state.formData.rule_start_date).getTime()
        const end = new Date(state.formData.rule_end_date).getTime()
        //所选时间要小于配规结束时间
        return !((date.getTime()) >= start - 1000*60*60*24 && (date.getTime()) <= end);
    }
    const isFestival = (date) => {
        // 获取当前年份
        var currentYear = new Date().getFullYear();
        // 获取当年春节
        var lunar = Lunar.Lunar.fromYmd(currentYear, 1, 1);
        // 获取下年春节
        var lunarNext = Lunar.Lunar.fromYmd(currentYear+1, 1, 1);
        // 转阳历春节日期
        var solar = lunar.getSolar().toString();
        var solarNext = lunarNext.getSolar().toString();
        //判断是否为当前春节前30天和春节后10天
        const newYearStart = new Date(solar).getTime() - 1000*60*60*24*30
        const newYearEnd = new Date(solar).getTime() + 1000*60*60*24*10
        state.newYearEnd = newYearEnd + 1000*60*60*24*2

        //判断是否为下年春节前30天和春节后10天
        const NextYearStart = new Date(solarNext).getTime() - 1000*60*60*24*30
        const NextYearEnd = new Date(solarNext).getTime() + 1000*60*60*24*10
        state.NextYearEnd = NextYearEnd + 1000*60*60*24*2
        return isWithinRange(date, newYearStart, newYearEnd) || isWithinRange(date, NextYearStart, NextYearEnd);
    } 
    const isSpecialDate = () =>{
        const currentDate = new Date().getTime(); // 当前日期时间戳
        // state.currentDate = currentDate
        // 获取当前年份
        var currentYear = new Date().getFullYear();
        // 计算国庆节日期范围
        const nationalDayEnd = new Date(currentYear, 9, 9).getTime()
        state.nationalDayEnd = nationalDayEnd
        // 判断是否在国庆节或春节日期范围内
        if (isFestival(currentDate) || isNationalDayRange(currentDate)) {
            return true;
        }
        
        return false;
    }
    // 获取商品详情
    const getList = () => {
        proxy.$http.get('/admin/brands/get_cjrule_info', {id:route.query.id}).then(res => {
                const { code, data, msg } = res
                if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
                Object.assign(state.formData, data)
            })
    }
    //获取品牌的配送类型
    const getShipType = () => {
        store.dispatch(AppActionTypes.ACTION_SET_GLOBALLOADING, true)
        proxy.$http.get('/admin/brands/get_cjrule_type', {user_id:userId,user_name:userName}).then(res => {
                store.dispatch(AppActionTypes.ACTION_SET_GLOBALLOADING, false)
                const { code, data, msg } = res
                if (code!= 200) { return proxy.$message({ type: 'error', message: msg }) }
                state.shipType = data
                if(data=='上门/自提'){
                    state.formData.ship_type = 2
                }else if(data=='快递'){
                    state.formData.ship_type = 1
                }
            })
    }
    //监听配规时间来约束自提配送时间
    const changeRuleDate = (val) => {
        state.formData.stop_start_date = ''
        state.formData.stop_end_date = ''
        state.formData.ship_start_date = ''
        state.formData.ship_end_date = ''
        state.formData.take_start_date = ''
        state.formData.take_end_date = ''
    }
    //监听是否营业
    const handleChangeTrade = (val) => {
       //选择营业则自提和配送选择一个
       if(val == 1 && state.formData.can_take == 2 && state.formData.can_ship == 2){
            return proxy.$message({ message: '自提和配送至少选择一个' })
        }
    }
    // 商品表单验证规则
    const standardForm = reactive({
        rule_start_date: [
            { required: true, message: '请输入配规开始时间', type: 'change', }
        ],
        brand_id: [
            { required: true, message: '请选择品牌id', trigger: 'change' }
        ],
        ship_type: [
            { required: true, message: '请选择配送类型', trigger: 'change' },
        ],
        distribution_range: [
            { required: true, message: '请输入配规描述', trigger: 'blur' }
        ],
        city_id: [
            { required: true, message: '请选择城市', trigger: 'change' },
        ],
        ship_amount: [
            { required: true, message: '请输入运费', trigger: 'blur' }
        ],
        white_reson: [
            { required: true, message: '请输入白名单申请原因', trigger: 'blur' }
        ],
        yingye_status: [
            { required: true, message: '请选择是否营业', trigger: 'change' }
        ],
        stop_start_date: [
            { required: true, message: '请选择闭店时间', trigger: 'change' }
        ],
        can_ship: [
            { required: true, message: '请选择是否上门配送', trigger: 'change' }
        ],
        ship_start_date: [
            { required: true, message: '请选择配送时间', trigger: 'change' }
        ],
        ship_times: [
            { required: true, message: '请输入配送时间段', trigger: 'blur' }
        ],
        can_take: [
            { required: true, message: '请选择是否支持门店自提', trigger: 'change' }
        ],
        take_start_date: [
            { required: true, message: '请选择自提起止时间', trigger: 'change' }
        ],
        take_times: [
            { required: true, message: '请输入自提时间段', trigger: 'blur' }
        ],
    })
    watch(() => state.formData.brand_id, (newVal, oldVal) => {
        getCityList()
    })
    watch(() => state.formData.yingye_status, (newVal, oldVal) => {
        //监听营业时间 来对自提和配送进行监控
        //由营业到不营业
        if(oldVal == 1 && newVal ==2){
            state.formData.can_ship = ''
            state.formData.ship_start_date = ''
            state.formData.ship_end_date = ''
            state.formData.ship_times = ''

            state.formData.can_take = ''
            state.formData.take_start_date = ''
            state.formData.take_end_date = ''
            state.formData.take_times = ''

        }
        //由不营业到营业 将闭店时间清空
        if(oldVal == 2 && newVal ==1){
            state.formData.stop_start_date = ''
            state.formData.stop_end_date = ''
        }
    })
    watch(() => state.formData.ship_type, (newVal, oldVal) => {
        //监听配送类型
        //由快递到上门、自提 将快递的信息清除
        if(oldVal == 1 && newVal ==2){
            state.formData.distribution_range = ''
            state.formData.ship_amount = ''
            

        }
        //由上门、自提到快递 将上门、自提的清除
        if(oldVal == 2 && newVal ==1){
            state.formData.city_id = ''

            state.formData.ship_amount = ''
            state.formData.yingye_status = ''

            state.formData.stop_start_date = ''
            state.formData.stop_end_date = ''

            state.formData.can_ship = ''
            state.formData.ship_start_date = ''
            state.formData.ship_end_date = ''
            state.formData.ship_times = ''

            state.formData.can_take = ''
            state.formData.take_start_date = ''
            state.formData.take_end_date = ''
            state.formData.take_times = ''
        }
    })
    onMounted(() => {
        route.query.id && getList()
        if(userType == 2){
            getShipType()
        }
        getBrandList()
        isSpecialDate()
    })
    return { ...toRefs(state),router,standardForm,onBrandChange,isFestival,isSpecialDate,getCityList,disabledStartRuleDate,disabledEndRuleDate,disabledStartDate,disabledEndDate,disabledStartStopDate,disabledEndStopDate,changeRuleDate,handleChangeTrade,userName}
}
})
